import React from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { invoices } from '../../../modules/customer/profile';
import SimpleTable from '../../components/SimpleTable';
import { profile } from '../../../modules/customer';
import { push } from 'connected-react-router';
import { BoxesRow, Box } from '../profilePage/components';

const Invoices = ({invoiceList, isLoading, getPDF, customerId, backToProfileView}) => {
    const columns = [
        { title: 'Invoice number', dataIndex: 'invoiceNumber', key: 'invoiceNumber', width: 200 },
        { title: 'Due date', dataIndex: 'dueDate', key: 'dueDate', width: 150 },
        { title: 'Id', dataIndex: 'id', key: 'id', width: 150 },
        { title: 'Amount', dataIndex: 'amount', key: 'amount', width: 150 },
        { title: 'Status', dataIndex: 'status', key: 'status', width: 150 },
        {
            title: 'PDF', dataIndex: 'pdf', key: 'pdf', width: 150, render: (text, record, props) =>
                <div>
                    {record.pdfAvailable
                        && <div>
                            <img
                                className="icon"
                                src="/icons/pdf_ic.svg"
                                alt="PDF" />
                            <ul className="linkList">
                                <li>
                                    <a onClick={e => {
                                        e.preventDefault();
                                        getPDF(customerId, record.invoiceNumber)
                                    }} href="#">forhåndsvisning</a>
                                </li>
                                {/*<li> // that option we will be on in the future
                                    <a href="#">send på e-post</a>
                                </li>*/}
                            </ul>
                        </div>
                    }
                </div>
        },
    ];
    return <BoxesRow>
        <Box label="Faktura">
        <SimpleTable
            columns={columns}
            data={invoiceList}
            isLoading={isLoading}
        />
        </Box>
    </BoxesRow>;
};

const mapDispatchToProps = (dispatch, props) => ({
    getPDF: (customerId, invoiceNumber) => dispatch(invoices.actions.fetchInvocePdf(customerId, invoiceNumber)),
    backToProfileView: (customerId) => dispatch(push(`/customer/${customerId}`))
});

const mapStateToProps = createStructuredSelector({
    invoiceList: invoices.selectors.getInvoices,
    isLoading: invoices.selectors.isLoading,
    customerId: profile.selectors.getCustomerID
});

export default connect(mapStateToProps, mapDispatchToProps)(Invoices);